document.addEventListener('DOMContentLoaded', function () {
  var cookieLink =
    document.querySelector('a[href="/pages/cookie-settings"]') ||
    document.querySelector('a[href="#cookie-settings"]');

  if (!cookieLink) return;

  cookieLink.addEventListener('click', function (event) {
    event.preventDefault();

    // Shopify Cookie Banner API
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences().catch(function (err) {
        console.error('Error opening cookie preferences:', err);
      });
      return;
    }

    // Fallback (one page reload, stay on current page)
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('preview_privacy_banner') !== '1') {
        url.searchParams.set('preview_privacy_banner', '1');
        window.location.replace(url.toString());
      }
    } catch (e) {
      console.error('Cookie settings fallback failed:', e);
    }
  });
});
